export default {
  comparePlans: 'Comparar Planes',
  plan1: 'Plan 1',
  plan2: 'Plan 2',
  selectPlanToCompare: 'Por favor seleccione un Plan para comparar',
  betaOptimizerTooltip: 'Este plan usa el nuevo optimizador (beta)',
  fullPeriodSummary: 'Resumen del Período Completo',
  monthlyDetailView: 'Vista Detallada Mensual',
  weeklyDetailView: 'Vista Detallada Semanal',
  touchpoints: 'Puntos de Contacto',
  segments: 'Segmentos'
}
